import FilterSection from "./FilterSection";

import useFilterState from "hooks/useFilterState";
import PriceRange from "./PriceRange";

export default function ProductFilters({ filterData, prices }) {
  const { handleSelect, filterDataWithSelectedValues } =
    useFilterState(filterData);

  return (
    <div className="min-w-[230px] xl:w-[270px] pt-5">
      {prices && <PriceRange prices={prices} />}
      {filterDataWithSelectedValues.map((filterOption) => (
        <FilterSection
          key={filterOption.slug}
          name={filterOption.name}
          slug={filterOption.slug}
          selectedValue={filterOption.selectedValue}
          onSelect={(data) => handleSelect(filterOption.slug, data)}
          isOpen={filterOption.selectedValue.length > 0}
          attributeList={filterOption.values}
        ></FilterSection>
      ))}
    </div>
  );
}
